import styled from 'styled-components';
// import Balancer from 'react-wrap-balancer';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import rehypeExternalLinks from 'rehype-external-links';

import FieldContextFeeder from '../components/FieldContextFeeder';

const ParagraphField = ({ placeholder }) => {
  return (
    <Container>
      <ReactMarkdown
        remarkPlugins={[remarkGfm]}
        rehypePlugins={[[rehypeExternalLinks, { target: '_blank' }]]}
      >
        {placeholder}
      </ReactMarkdown>
    </Container>
  );
};

const Container = styled.p`
  // max-width: var(--field-width);
  hyphens: auto;
  word-break: break-word;

  a {
    color: var(--green);
    text-decoration: underline;

    &:hover {
      color: var(--green);
    }

    &::after {
      font-family: 'Font Awesome 5 Free';
      content: '\f35d';
      font-weight: 900;
      font-size: 14px;
      margin-left: 4px;
      margin-right: 3px;
      text-decoration: none;
    }
  }
`;

export default FieldContextFeeder(ParagraphField);
